/**
 * The host a miniapp is running inside, as reported by the SDK's host-info `platform` field.
 *
 * These are VERIFIED AGAINST A LIVE HOST, not read off anyone's `package.json`. Do not infer a new
 * one from source: the portal's handler happens to answer with its package name, and assuming the
 * others do the same put `consumer-web` here for tenant-web, which is wrong -- it answers `web`.
 * Confirm against a running host before adding an entry.
 */
export const HOST_PLATFORMS = {
  TENANT_PORTAL: 'tenant-portal',
  /**
   * tenant-web. Listed so nobody has to re-derive it -- and deliberately NOT used for gating.
   *
   * There is no `isDesktopHost`-style helper here on purpose. tenant-web is a desktop host that
   * frames these pages with NO chrome of its own, so anything that treats it like the portal strips
   * the back button and leaves the reader with no way out. The distinction that matters is "does the
   * host draw its own back affordance", and only the portal does.
   */
  WEB: 'web',
} as const;

export type HostPlatform = (typeof HOST_PLATFORMS)[keyof typeof HOST_PLATFORMS] | string;
